var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',[_c('lead-wizard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }